import { fetchStocks } from "./inventoryAction";
import { fetchTranferTypes } from "./transferAction";
import { formatData } from "./utils";

export function fetchSales(){
    console.log("FIRED ACTION FETCH SALES" )
    return async function(dispatch){
        dispatch({
            type: "FETCH_SALES_START",
            payload: ""
            
        })
        try {
            const response = await fetch('/stocks/getList',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page:"sales",
                }),
                credentials: 'same-origin',
            }); 
            
            const salesList = await response.json()
            console.log(salesList)// salesList returns new object created

            if(!salesList.error){ // no errors, return new Object
                
                dispatch(getSales(formatData(salesList.reverse()) ))
                dispatch({ type: "FETCH_SALES_FULFILLED", payload:"" })
                console.log("sales fetched")
                
                // dispatch(fetchStocks())
            
            } else {
                dispatch({
                    type: "FETCH_SALES_ERROR",
                    payload: salesList.error.message
                })
            }
            
        } catch (err) {
            dispatch({
                type: "FETCH_SALES_ERROR",
                payload: err
                
            })
        }
    }
}
export function createSale(newSale, page = "sales"){
    console.log("FIRED ACTION CREATE SALE", newSale)
    return async function(dispatch){
        dispatch({
            type: "CREATE_SALE_START",
            payload: ""
            
        })
        try {
            const response = await fetch('/stocks/addData',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page,
                    data:newSale
                }),
                credentials: 'same-origin',
            }); 
            
            const createdSale = await response.json()
            console.log(createdSale)// createdSale returns new object created
            console.log("createSale et id" +createdSale.id)// createdSale returns new object created

            //Test si vente ou si reappro
            if(typeof createdSale.id != "undefined" && newSale && newSale.client && newSale.client.id) { // no errors, return new Object
                //Si vente
                newSale.client.id = createdSale.client_ref
                dispatch({
                    type:"NEW_CLIENT",
                    payload: newSale.client
                })
                const saleType = newSale.nature === "quote" ? "NEW_QUOTE" : "NEW_SALE"
                dispatch({
                    type: saleType,
                    payload: createdSale
                })
                dispatch({ type: "CREATE_SALE_FULFILLED", payload:"" })
                console.log(page ," created")
                
                dispatch(fetchStocks())
                return "OK";
            } else if(createdSale && typeof createdSale.id != "undefined"){ // no errors, reappro return sale and dest shoppurchase
                // dispatch({
                //     type:"NEW_PURCHASE_REAPPRO",
                //     payload: createdSale.purchase
                // })
                dispatch({
                    type:"NEW_SALE_REAPPRO",
                    payload: createdSale
                })
                dispatch({ type: "CREATE_SALE_FULFILLED", payload:"" })
                
                dispatch(fetchStocks())
                // Force refresh the reappro list in case components don't refetch by themselves
                try {
                    dispatch(fetchTranferTypes("reapprovisionnement"));
                } catch (e) {
                }
                return "OK";
            } else {
                dispatch({
                    type: "CREATE_SALE_ERROR",
                    payload: createdSale.error.message
                })
            }
            throw new Error(createdSale.error.message)
        } catch (err) {
            console.log('====================================');
            console.log("error create sale", err);
            console.log('====================================');
            dispatch({
                type: "CREATE_SALE_ERROR",
                payload: err
                
            })
            throw err
        }
    }
}
export function validatePrepa(prepa){
    return async function(dispatch){
        dispatch({
            type: "VALIDATE_PREPA_START",
            payload: ""
            
        })
        try {
            const response = await fetch('/stocks/prepaToSale',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    data:prepa
                }),
                credentials: 'same-origin',
            }); 
            
            const createdSale = await response.json()
            console.log(createdSale)// createdSale returns new object created

            if(createdSale.id){ // no errors, return new Object
                dispatch({ type: "UPDATE_SALE", payload: createdSale })
                dispatch({ type: "VALIDATE_PREPA_FULFILLED", payload:"" })

                dispatch(fetchStocks())
            } else {
                dispatch({
                    type: "VALIDATE_PREPA_ERROR",
                    payload: createdSale.error.message
                })
            }
            
        } catch (err) {
            dispatch({
                type: "VALIDATE_PREPA_ERROR",
                payload: err
                
            })
        }
    }
}
export function deletePrepa(prepa){
    return async function(dispatch){
        dispatch({
            type: "DELETE_PREPA_START",
            payload: ""
            
        })
        try {
            const response = await fetch('/stocks/deletePrepa',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    data:prepa
                }),
                credentials: 'same-origin',
            }); 
            const body = await response.json()
            console.log("DELETE PREPA RESPONSE",{body})

            if(body){ // no errors, return new Object
                dispatch({
                    type: "DELETE_PREPA",
                    payload: prepa.prepa_id
                })
                dispatch({ type: "DELETE_PREPA_FULFILLED", payload:"" })
                
                dispatch(fetchStocks())
            } else {
                dispatch({
                    type: "DELETE_PREPA_ERROR",
                    payload: prepa.error.message
                })
            }
            
        } catch (err) {
            dispatch({
                type: "DELETE_PREPA_ERROR",
                payload: err
                
            })
        }
    }
}
export function deleteSale(sale){
    return async function(dispatch){
        dispatch({ type: "DELETE_SALE_START", payload: "" })
        try {
            const response = await fetch('/stocks/delete',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    type:"sale",
                    data:sale
                }),
                credentials: 'same-origin',
            }); 
            const body = await response.json()
            console.log("DELETE SALE RESPONSE",{body})

            if(!body.error){ // no errors, return new Object
                dispatch({ type: "DELETE_SALE", payload: sale.id })
                dispatch({ type: "DELETE_SALE_FULFILLED", payload:"" })
                dispatch(fetchStocks())
                return "OK"
            } else {
                dispatch({
                    type: "DELETE_SALE_ERROR",
                    payload: body.error.message
                })
            }
            throw new Error(body.error.message)
        } catch (err) {
            dispatch({  type: "DELETE_SALE_ERROR", payload: err })
            throw err 
        }
    }
}

export function receiveReappro(reappro){
    console.log("FIRED ACTION RECEIVE REAPPRO", reappro)
    return async function(dispatch){
        dispatch({ type: "RECEIVE_REAPPRO_START", payload: "" })
        try {
            const infos = await fetch('/stocks/changeStatus',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify(reappro),
                credentials: 'same-origin',
            });
            let updatedRea = await infos.json();
            console.log("[INFO] change status receive reappro ",updatedRea);// return true or false
            
            if(updatedRea.id){ // no errors, return new Object
                dispatch({ type: "UPDATE_REAPPRO", payload: updatedRea })
                dispatch({ type: "RECEIVE_REAPPRO_FULFILLED", payload:"" })
                console.log("reappro UPDATED ")

                dispatch(fetchStocks())
            } else {
                dispatch({ type: "RECEIVE_REAPPRO_ERROR", payload: updatedRea.error.message })
            }
            
        } catch (err) {
            console.log("[ERROR] SUBMIT REAPPRO ", err);
            dispatch({ type: "RECEIVE_REAPPRO_ERROR", payload: err })
        }
    }
}

export function deleteReappro(reappro){
    return async function(dispatch){
        dispatch({ type: "DELETE_SALE_START", payload: "" })
        try {
            const response = await fetch('/stocks/delete',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    type:"reappro",
                    data:reappro
                }),
                credentials: 'same-origin',
            }); 
            const body = await response.json()
            console.log("DELETE REAPPRO RESPONSE",{body})

            if(!body.error){ // no errors, return new Object
                dispatch({ type: "DELETE_REAPPRO", payload: reappro.id })
                dispatch({ type: "DELETE_PURCHASE", payload: reappro.reappro_purchase_id })
                dispatch({ type: "DELETE_SALE_FULFILLED", payload:"" })
                dispatch(fetchStocks())
                return "OK"
            } else {
                dispatch({
                    type: "DELETE_SALE_ERROR",
                    payload: body.error.message
                })
            }
            throw new Error(body.error.message)
        } catch (err) {
            dispatch({  type: "DELETE_SALE_ERROR", payload: err })
            throw err
        }
    }
}

export function linkSalesTo5000(data){
    return async function (dispatch){
        dispatch({ type: "LINK_PAYMENTS_START", payload: "" })
        try {
            const req = await fetch('/stocks/addData',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page:"sales/link/to/compta",
                    data:data
                }),
                credentials: 'same-origin',
            }); 
            
            let res = await req.json();
            console.log('linkSalesTo5000 res : ', res);

            if(!res.error){ // no errors, return new Object 
                try {
                    const req2 = await fetch('/money/link/update/income', {
                        method: 'POST',
                        body: JSON.stringify({income_id: data.income_id, income_total_available: res }),
                        headers: {
                            'Content-Type': 'application/json',
                            //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                        },
                        credentials: 'same-origin',
                    });
                    let res2 = await req2.json();
                    console.log('linkSalesTo5000 res2 update income : ', res2);

                    if(!res2.error){ // no errors, return new Object 
                        // data = {
                        //     income_id : "",
                        //     id_list: []string, OLD 
                        //     id_list: map[sale_id]amount, 
                        //     total: float64
                        // }
                        dispatch({
                            type: "UPDATE_SALES_LINK",
                            payload: {list: Object.keys(data.id_list), income_id: data.income_id} 
                        })
        
                        dispatch({ type: "LINK_SALES_FULFILLED", payload: "" }) 
                    
                    } else {
                        dispatch({
                            type: "LINK_SALES_ERROR",
                            payload: res2.error
                        })
                    }
                } catch (error) {
                    console.log("[ERROR] link payments to compta : ", error);
                    dispatch({
                        type: "LINK_SALES_ERROR",
                        payload: error.message
                    })
                } 
            
            } else {
                dispatch({
                    type: "LINK_SALES_ERROR",
                    payload: res.error
                })
            }
        } catch (error) {
            console.log("[ERROR] link payments to compta : ", error);
            dispatch({ type: "LINK_SALES_ERROR", payload: error.message })
        }     
    }
}
export function unLinkSalesTo5000(data){
    return async function (dispatch){
        dispatch({ type: "LINK_SALES_START", payload: "" })
        try {
            const req = await fetch('/stocks/addData',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    page:"sales/unlink/to/compta",
                    data:data
                }),
                credentials: 'same-origin',
            }); 
            
            let res = await req.json();
            console.log('unLinkSalesTo5000 res : ', res);
            if(!res.error){ // no errors, return new Object
                try {
                    const req2 = await fetch('/money/link/update/income', {
                        method: 'POST',
                        body: JSON.stringify({income_id: data.income_id, income_total_available: data.total * -1 }),
                        headers: {
                            'Content-Type': 'application/json',
                            //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                        },
                        credentials: 'same-origin',
                    });
                    let res2 = await req2.json();
                    console.log('unLinkSalesTo5000 res2 update income : ', res2);

                    if(!res2.error){ // no errors, return new Object 
                        dispatch({
                            type: "UPDATE_SALES_UNLINK",
                            payload: {list: Object.values(data.id_list)} 
                        })
                        dispatch({ type: "LINK_SALES_FULFILLED", payload: "" }) 
                    
                    } else {
                        dispatch({
                            type: "LINK_SALES_ERROR",
                            payload: res2.error
                        })
                    }
                } catch (error) {
                    console.log("[ERROR] link payments to compta : ", error);
                    dispatch({
                        type: "LINK_SALES_ERROR",
                        payload: error.message
                    })
                }             
            } else {
                dispatch({
                    type: "LINK_SALES_ERROR",
                    payload: res.error
                })
            }
        } catch (error) {
            console.log("[ERROR] link payments to compta : ", error);
            dispatch({ type: "LINK_SALES_ERROR", payload: error.message })
        }
         
    }
}

export function getSalesOld(sales){
    // console.log("FIRED ACTION GET SALES", sales)
    return {
        type: "GET_SALES",
        payload: sales
        
    }
}

export function getSales(sales){
    
    let newList = {
        SALES : {},
        REAPPRO : {},
        REAPPRO_EXT : {},
        DEVIS : {},
        ALL : sales,
    }
    Object.keys(sales).map((saleID) => {
        if(sales[saleID].nature === 'reapprovisionnement'){
            newList.REAPPRO[saleID] = sales[saleID]
        } else if(sales[saleID].nature === 'reapprovisionnement_ext'){
            newList.REAPPRO_EXT[saleID] = sales[saleID]
        } else if(sales[saleID].nature === 'devis'){
            newList.DEVIS[saleID] = sales[saleID]
        } else {
            newList.SALES[saleID] = sales[saleID]
        }
    })
    newList.SALES = newList.SALES && sortByDate(Object.values(newList.SALES))
    newList.REAPPRO_EXT = newList.REAPPRO_EXT && sortByDate(Object.values(newList.REAPPRO_EXT))
    newList.REAPPRO = newList.REAPPRO && sortByDate(Object.values(newList.REAPPRO))
    newList.DEVIS = newList.DEVIS && sortByDate(Object.values(newList.DEVIS))
    newList.ALL = newList.ALL && sortByDate(Object.values(newList.ALL))

    return {
        type: "GET_SALES",
        payload: newList
        
    }
    
}
export function getSale(sale_Id){
    // console.log("FIRED ACTION GET SALES", sales)
    return {
        type: "GET_SALE",
        payload: sale_Id
        
    }
}
function sortByDate(list, field = 'date') {
    // console.log(list);
    let newList = {}
    list.sort( (a, b) => {
        return new Date(b[field]) - new Date(a[field])
    });

    list.map( item => {
        newList[item.id] = item
    })

    // console.log('====================================');
    // console.log({ newList, list});
    // console.log('====================================');
    return newList
  } 